import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';


class Month extends Component {
  constructor(props) {
    super(props);

    this.state = {
      monthList: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    }
  }  
  render() {
    let display = "";
    if(this.props.selected) {
      display = this.props.month;
    }    
    return (   
      <Dropdown onFocus={this.props.onFocus} onBlur={this.props.onBlur} isOpen={this.props.isOpen} toggle={this.props.toggle}>
        <DropdownToggle name="month" id="month" autoFocus={this.props.autoFocus}>{display}</DropdownToggle>
        <DropdownMenu>
          <div className="close" onClick={this.props.toggle}></div>
          <div className="heading">Month</div>
          {this.state.monthList.map((month, i) =>{
            return (
              <div className="dropdown-item-container" key={i} >
                <DropdownItem name={month} onClick={this.props.select} active={month === this.props.month ? true : null}>{month}</DropdownItem>
              </div>
            );
          })}                            
        </DropdownMenu>
      </Dropdown>    
      );
  }
}
Month.defaultProps= {
  isOpen: false,
  toggle: () => {},
  select: () => {},
  month: "Jan",
  selected: false,
  autoFocus: false
};

Month.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  select: PropTypes.func,
  Month: PropTypes.string,
  selected: PropTypes.bool,
  autoFocus: PropTypes.bool
};

export default Month;


// WEBPACK FOOTER //
// ./src/components/DatePicker/Month.js